import { normaliseLocaleTag, readStoredLocale, type SupportedLocale } from "@patient-watch/i18n";
import { useEffect, useRef } from "react";
import { useAuth } from "@/utils/auth";
import { useUserLocaleQuery } from "./api/selectUserLocale";
import { usePreferredLocaleMutation } from "./usePreferredLocaleMutation";

/** Persist programme / stored / resolved display locale to profile when preferred_locale is still NULL. */
export function useSyncPreferredLocaleIfUnset(programmeLocale?: string | null, displayLocale?: SupportedLocale | null) {
    const auth = useAuth();
    const { data: userPreferredLocale, isSuccess } = useUserLocaleQuery(auth.id);
    const { mutate: persistPreferredLocale } = usePreferredLocaleMutation(auth.id ?? "");
    const syncedUserIdRef = useRef<string | null>(null);

    useEffect(() => {
        if (!auth.id || !isSuccess || userPreferredLocale) return;
        if (syncedUserIdRef.current === auth.id) return;

        const toPersist =
            normaliseLocaleTag(programmeLocale) ?? normaliseLocaleTag(readStoredLocale()) ?? displayLocale ?? null;
        if (!toPersist) return;

        syncedUserIdRef.current = auth.id;
        persistPreferredLocale(toPersist);
    }, [auth.id, isSuccess, userPreferredLocale, programmeLocale, displayLocale, persistPreferredLocale]);
}
